module.exports = __webpack_public_path__ + "static/media/img-placeholder.eaaaa7f2.png";